import React from "react";

import { ListingTable } from "../../../../../components/layout/listing-table/listing-table.component";
import { SpinnerLoader } from "../../../../../components/loaders";
import { FileDrop } from "../../../../../components/file-drop/file-drop.component";

import { FileUploadButton } from "../file-upload-button/file-upload-button.component";

import { FileUploadSectionProps } from "./file-upload-section.props";
import { AssetListSection, UploadSection, FileUpload } from "./file-upload-section.styles";
import { getDefaultAssetTableColumns } from "../file-upload-assets-table/types/file-upload-assets-table.functions";
import { IAssetsTableColumnsOptions } from "../file-upload-assets-table/types/file-upload-assets-table.interface";

export const FileUploadSection = (props: FileUploadSectionProps) => {
  const onUploadFile = (file: File) => props.onUpload([file]);

  const { canDelete = false, canDownload = true, showDeleteButton = true } = props;

  const listingColumnsOptions: IAssetsTableColumnsOptions = {
    canDelete,
    canDownload,
    onDelete: props.onDelete,
    showDeleteButton,
  };
  const getListingColumns = () =>
    (props.listingColumns && props.listingColumns(listingColumnsOptions)) ||
    getDefaultAssetTableColumns(listingColumnsOptions);

  return (
    <>
      <SpinnerLoader showIf={props.isLoading} hasBackdrop={true} />
      <FileUploadButton accept={props.accept} onUpload={onUploadFile} />
      <AssetListSection>
        <ListingTable
          showIf={Boolean(props.assets.length)}
          columns={getListingColumns()}
          dataList={props.assets}
          headers={false}
        />
      </AssetListSection>
      <UploadSection>
        <FileUpload>
          <FileDrop accept={props.accept} onDrop={props.onUpload} />
        </FileUpload>
      </UploadSection>
    </>
  );
};
